/**
 * 模組代碼 : -
 * 模組說明 : (共用模組) 密碼輸入欄位
 * @module web/components/PasswordInput
 */

// ----- import from npm modules -----
import React, {useState, useRef, useEffect} from 'react';

/**
 *
 */
function PasswordInput({
  id,
  name,
  value,
  confirmValue,
  onChange,
  validateType,
  defaultMassage,
  size = 'sm',
}) {
  const inputRef = useRef();
  const [showPassword, setShowPassword] = useState(false);
  const [validationMessage, setValidationMessage] = useState('');

  const handleTogglePasswordVisibility = () => {
    setShowPassword((prevShowPassword) => !prevShowPassword);
  };

  const validateLoginPassword = (value) => {
    /* const password = value.toString().trim();
        if (password === '') {
            return '密碼不可為空';
        }*/
    return '';
  };

  const validateNewPassword = (value, confirmValue) => {
    const password = value.toString().trim();
    const oldPassword =
      confirmValue !== null ? confirmValue.toString().trim() : null;
    if (!password) {
      return '新密碼不可為空';
    }

    if (password) {
      if (oldPassword !== null && password === oldPassword) {
        return '新密碼不可與舊密碼相同';
      }

      // const isLengthValid = password.length >= 8 && password.length <= 16;
      // const hasUpperCase = /[A-Z]/.test(password);
      // const hasLowerCase = /[a-z]/.test(password);
      const hasEnglish = /[a-zA-Z]/.test(password);
      const hasNumber = /\d/.test(password);
      // const hasSpecialChar = /[!@#$%^&*()_`+\.\-=\[\]:';"<>/?,]/.test(password);

      const isPasswordValid = hasEnglish && hasNumber;
      // isLengthValid &&
      // hasEnglish &&
      // hasLowerCase &&
      // hasNumber &&
      // hasSpecialChar;

      if (!isPasswordValid) {
        console.log(isPasswordValid);

        return '密碼需至少包含1個大寫或小寫英文與1個數字';
      }
    }
    return '';
  };

  const validateConfirmPassword = (value, confirmValue) => {
    const confirmPassword = value.toString().trim();
    const newPassword = confirmValue.toString().trim();
    if (!confirmPassword) {
      return '確認密碼不可為空';
    }

    if (confirmPassword && newPassword && confirmPassword !== newPassword) {
      return '請確認與輸入密碼相符';
    }

    return '';
  };

  const validateOldPassword = (value) => {
    const oldPassword = value.toString().trim();
    if (!oldPassword) {
      return '舊密碼不可為空';
    }
    return '';
  };

  const validatePassword = (value, confirmValue, validateType) => {
    switch (validateType) {
      case 'login':
        return validateLoginPassword(value);
      case 'password':
        return validateNewPassword(value, null);
      case 'newPassword':
        return validateNewPassword(value, confirmValue);
      case 'confirmPassword':
        return validateConfirmPassword(value, confirmValue);
      case 'oldPassword':
        return validateOldPassword(value);
      default:
        return '';
    }
  };

  const handleChange = (event) => {
    const passwordInput = inputRef.current;
    const value = event.target.value;
    onChange(event);

    const validateMessage = validatePassword(value, confirmValue, validateType);
    const isPasswordValid = validateMessage === '' ? true : false;
    passwordInput.classList.toggle(
      'is-valid',
      isPasswordValid && passwordInput.checkValidity(),
    );
    passwordInput.classList.toggle('is-invalid', !isPasswordValid);

    if (!isPasswordValid) {
      passwordInput.setCustomValidity('Password must meet all requirements.');
      setValidationMessage(validateMessage);
    } else {
      passwordInput.setCustomValidity('');
    }
  };

  useEffect(() => {
    setValidationMessage(defaultMassage || '');
  }, []);

  return (
    <div
      className={`input-group password-toggle ${
        size === 'sm' ? 'input-group-sm' : ''
      }`}
    >
      <input
        type={showPassword ? 'text' : 'password'}
        id={id}
        name={name}
        className="form-control"
        placeholder=""
        value={value}
        ref={inputRef}
        onChange={handleChange}
        required
      />
      <button
        type="button"
        onClick={handleTogglePasswordVisibility}
        aria-label=""
      ></button>
      {validationMessage && (
        <div className="invalid-feedback">{validationMessage}</div>
      )}
    </div>
  );
}

export default PasswordInput;
